import { render, staticRenderFns } from "./basicStep.vue?vue&type=template&id=7b60a18e&scoped=true"
import script from "./basicStep.vue?vue&type=script&lang=js"
export * from "./basicStep.vue?vue&type=script&lang=js"
import style0 from "./basicStep.vue?vue&type=style&index=0&id=7b60a18e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.7.4_vue-template-compiler@2.7.14_webpack@5.83.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b60a18e",
  null
  
)

export default component.exports